import { render, staticRenderFns } from "./OperationsForecastPage.vue?vue&type=template&id=bc412efe&"
import script from "./OperationsForecastPage.vue?vue&type=script&lang=js&"
export * from "./OperationsForecastPage.vue?vue&type=script&lang=js&"
import style0 from "./OperationsForecastPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports